// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcasts-cls1_ngr","cls2":"RecommendedPodcasts-cls2_T23 RecommendedPodcasts-cls1_ngr"};